import * as React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { CheckCircle2, MessageSquareText } from 'lucide-react'
import type { MessagingPlatform } from '@axilon-apps/domains-ontology-ui-state'

import { Button } from '../../components/ui/button'
import { Card, CardContent } from '../../components/ui/card'

const PLATFORM_LABELS: Record<MessagingPlatform, string> = {
  teams: 'Microsoft Teams',
  slack: 'Slack'
}

function platformLabel(value: string | null): string {
  if (value === 'teams' || value === 'slack') return PLATFORM_LABELS[value]
  return 'Messaging'
}

export default function MessagingConnectSuccessPage(): React.JSX.Element {
  const [searchParams] = useSearchParams()
  const label = platformLabel(searchParams.get('platform'))
  const tenantId = searchParams.get('tenant_id') ?? ''
  const tenantName = searchParams.get('tenant_name') ?? ''
  const alreadyConnected = searchParams.get('status') === 'already_connected'
  const displayName = tenantName || tenantId

  return (
    <main className="min-h-screen bg-bg px-4 py-16 text-ink">
      <Card className="mx-auto max-w-xl">
        <CardContent className="flex flex-col items-center gap-5 px-8 py-10 text-center">
          <div className="rounded-full bg-st-run-bg p-4 text-st-run">
            <CheckCircle2 size={34} />
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-ink-3">
              {alreadyConnected ? 'Already connected' : 'Connection complete'}
            </p>
            <h1 className="text-2xl font-semibold">
              {label} bot {alreadyConnected ? 'is already linked' : 'is linked'}
            </h1>
            <p className="text-sm text-ink-3">
              {displayName
                ? `${displayName} can now use ontology messaging workflows.`
                : 'This tenant can now use ontology messaging workflows.'}
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-2">
            <Button asChild>
              <Link to="/settings?tab=integrations">Open integrations</Link>
            </Button>
            <Button variant="outline" asChild>
              <Link to="/plant">
                <MessageSquareText />
                Back to ontology
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </main>
  )
}
